import { Outlet, useNavigate } from "react-router";
import LogoHeader from "@/components/logo-header/logo-header";

export default function FindPasswordLayout() {
  const navigate = useNavigate();

  return (
    <div style={{ paddingTop: "5rem" }}>
      <LogoHeader
        tapLogo={() => {
          navigate(-1);
        }}
      />
      <Outlet />
    </div>
  );
}
